import { useState } from 'react';

import { SortingDirection, SortingOffersValue } from '../constants/enums';

import { usePaginationFromURL } from './usePaginationFromURL';

interface SortingState {
  sortValue: SortingOffersValue;
  direction: SortingDirection;
}

export const useTableSorting = (initialSortValue: SortingOffersValue) => {
  const { sortValue, direction } = usePaginationFromURL('offers');
  
  const [sorting, setSorting] = useState<SortingState>({
    sortValue: sortValue || initialSortValue,
    direction: direction || SortingDirection.DESC
  });

  const updateSorting = (newSortValue: SortingOffersValue, newDirection: SortingDirection) => {
    setSorting({ sortValue: newSortValue, direction: newDirection });
  };

  return { sorting, updateSorting };
}; 